/**
 * Created by Jie Gao on 2018-06-14.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {TimelineLite, TweenLite} from "gsap";
import {DragonTribeGameModuleConfig} from "../../DragonTribeGameModuleConfig";
import {DTReelController} from "../../reel/DTReelController";
import {DragonTribeParsedGameData} from "../../server/data/DragonTribeParsedGameData";
import {DTReelSymbolM} from "../../symbols/DTReelSymbolM";
import {FreespinFeatureEvent} from "../../winpresentation/fswildmeter/events/FreespinFeatureEvent";

export class DTFreespinOutroController extends FreespinOutroController {

    constructor(config:IScreenConfig) {
        super(config);
    }

    protected calculateIsTriggered(data:DragonTribeParsedGameData):boolean {
        return (data.mode.indexOf("FREESPIN") > -1 && data.nextMode === GameMode.NORMAL);
    }

    public start():void {
        const tl:TimelineLite = new TimelineLite();
        tl.add(TweenLite.to(StageManager.stage.scale, 0.5, {x : 1, y : 1}));
        tl.add(() => {
            EventHandler.dispatchEvent(new GameEvent(FreespinFeatureEvent.HIDE_METER));
            super.start();
        });
    }

    protected show():boolean {
        EventHandler.dispatchEvent(new GameEvent(FreespinFeatureEvent.HIDE_METER));
        return super.show();
    }

    protected close():void {
        super.close();
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : GameMode.NORMAL}));
        DragonTribeGameModuleConfig.background.showFeatureLogo(-1);
        for(let i:number = 0; i < 6; i++) {
            const allSyms:(StateReelSymbol | null)[] = (<DTReelController>Reels.getReel(i)).allSymbols;
            allSyms.forEach((symbol:StateReelSymbol| null) => {
                if(symbol!.symName.indexOf("M") > -1) {
                    (<DTReelSymbolM>symbol!).isWild = false;
                }
            });
        }
        DragonTribeGameModuleConfig.featurePrice.reset();
    }
}